import { Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderComponent } from './content/common/components/header/header.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslationCustomLoaderComponent } from './core/utils/translation-custom-loader.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { LingMatPaginatorIntl } from './core/injectables/ling-mat-paginator-intl';
import {
  NgxGoogleAnalyticsModule,
  NgxGoogleAnalyticsRouterModule,
} from 'ngx-google-analytics';
import { environment } from '../environments/environment';
import { FooterComponent } from './content/common/components/footer/footer.component';
import { TourButtonComponent } from './content/common/components/tour-button/tour-button.component';
import { MatButtonModule } from '@angular/material/button';
import { LottieModule } from 'ngx-lottie';
import { PendingTagBarComponent } from './content/common/components/pending-tag-bar/pending-tag-bar.component';
import { UnsafeLinksHandlerDirective } from './core/directives/unsafe-links-handler/unsafe-links-handler.directive';

export function TranslationLoaderFactory() {
  return new TranslationCustomLoaderComponent();
}

// Export this function
export function playerFactory(): any {
  return import('lottie-web');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSnackBarModule,
    MatDialogModule,
    HeaderComponent,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslationLoaderFactory,
      },
    }),
    MatProgressSpinnerModule,
    TranslationCustomLoaderComponent,
    NgxGoogleAnalyticsModule.forRoot(environment.googleAnalytics),
    NgxGoogleAnalyticsRouterModule,
    FooterComponent,
    MatButtonModule,
    TourButtonComponent,
    LottieModule.forRoot({ player: playerFactory }),
    PendingTagBarComponent,
    UnsafeLinksHandlerDirective,
  ],
  providers: [{ provide: MatPaginatorIntl, useClass: LingMatPaginatorIntl }],
  bootstrap: [AppComponent],
})
export class AppModule {
  static injector: Injector;

  constructor(injector: Injector) {
    AppModule.injector = injector;
  }
}
